import { useState } from "react";
import { UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { api, mediaUrl } from "../../lib/api";

// Uploads a file to object storage via admin endpoint and returns the /api/files URL.
export function MediaUploadField({ value, onChange, testid }) {
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Uploaded");
    } catch (e) {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-3">
      {value && (
        <img src={mediaUrl(value)} alt="" className="w-full max-h-40 object-cover rounded-lg border border-slate-800" />
      )}
      <div className="flex gap-3">
        <label className="flex-1 flex items-center gap-2 bg-[#070b12] border border-dashed border-slate-700 rounded-lg px-4 py-3 cursor-pointer hover:border-emerald-500/50 transition-colors">
          <UploadCloud className="w-4 h-4 text-emerald-400" />
          <span className="text-slate-300 text-sm">{uploading ? "Uploading…" : "Upload image"}</span>
          <input type="file" accept="image/*" className="hidden" data-testid={testid} onChange={(e) => upload(e.target.files[0])} />
        </label>
      </div>
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="or paste an image URL"
        className="w-full bg-[#070b12] border border-slate-800 rounded-lg px-4 py-2.5 text-slate-200 text-sm focus:outline-none focus:border-emerald-500/50" />
    </div>
  );
}
